<template>
  <v-container>
    <div v-if="!loading">

      <SporiciProgramDialog v-if="sporici_program_id!=null" :id="sporici_program_id.toString()" :klient="klient" @close="sporici_program_id = null;"></SporiciProgramDialog>
      <VytvoritSporiciProgramDialog v-if="vytvoritSporiciProgram" :klient="klient" @close="vytvoritSporiciProgram=false;" @created="createdSporiciProgram"></VytvoritSporiciProgramDialog>

      <JednorazovyNakupDialog v-if="jednorazovy_nakup_id!=null" :id="jednorazovy_nakup_id.toString()" :klient="klient" @close="jednorazovy_nakup_id=null"></JednorazovyNakupDialog>
      <VytvoritJednorazovyNakupDialog v-if="vytvoritJednorazovyNakup" :klient="klient" @close="vytvoritJednorazovyNakup=false;" @created="createdJednorazovyNakup" :edit="vytvoritJednorazovyNakupEdit" :id="vytvoritJednorazovyNakupID"></VytvoritJednorazovyNakupDialog>

      <v-layout row wrap class="mt-2 mb-2" :class="{'mt-3': $vuetify.breakpoint.smAndDown}">
        <v-flex grow>
          <h2 class="mb-20">Postupné nákupy klienta</h2>
        </v-flex>
        <v-flex shrink>
          <v-btn color="orange" outline class="ma-0 mr-4" :class="{'mb-2': $vuetify.breakpoint.smAndDown}" @click="createClick">Vytvořit postupný nákup</v-btn>
        </v-flex>
      </v-layout>
      <v-layout v-if="!sporici_programy" row wrap>
        <p>Klient nemá žádné postupné nákupy.</p>
      </v-layout>
      <div v-else class="basket-item client-shopItem" v-for="n in sporici_programy">
        <div class="basket-item__div">
          <div class="text-center" style="width: 80px; text-align: center;">
            <img :src="n.cilovy_produkt.obrazky.length > 0 ? 'https://uw-comfort-com-images.s3.eu-west-1.amazonaws.com/' + n.cilovy_produkt.obrazky[0].s3_nazev : '@/assets/images/basket-item.png'" alt="">
          </div>
          <div class="flex-column">
            <div class="flex">
              <p class="item-title">{{n.nazev_sporeni}}</p>
              <p class="text-gray ml-3">{{n.datum_sjednani | formatSimpleDate}}</p>
            </div>
            <div class="flex flex-3">
              <p class="item-title text-gray">Naspořeno: {{n.nasporena_castka | formatMoney}} {{n.mena.zkratka}} / {{n.cilova_castka | formatMoney}} {{n.mena.zkratka}}</p>
              <p class="item-title text-gray">Měs. platba: {{n.mesicni_platba | formatMoney}} {{n.mena.zkratka}}</p>
              <p class="item-title text-gray">
                Stav: <span v-if="n.stav_sporeni = 'probiha'">Probíhá</span>
                <span v-else-if="n.stav_sporeni = 'dokonceno'">Dokončeno</span>
                <span v-else>Zrušeno</span>
              </p>
            </div>
          </div>
        </div>
        <div class="basket-item__div basket-item__delete">
          <p class="text-primary"></p>
          <v-btn color="orange" dark @click="openDetail(n)" depressed class="bold"><v-icon class="detail-icon">remove_red_eyes</v-icon>Detail</v-btn>
          <!-- <v-btn color="grey" dark depressed flat @click="upravitJN(n)"><v-icon class="mr-2">edit</v-icon> Upravit</v-btn> -->
        </div>
      </div>
      <v-layout row wrap class="mt-5 mb-2">
        <v-flex grow>
          <h2 class="mb-20">Jednorázové nákupy</h2>
        </v-flex>
        <v-flex shrink>
          <v-btn color="orange" outline class="ma-0 mr-4" :class="{'mb-2': $vuetify.breakpoint.smAndDown}" @click="createJNClick">Vytvořit objednávku</v-btn>
        </v-flex>
      </v-layout>
      <v-layout v-if="!jednorazove_nakupy" row wrap>
        <p>Klient nemá žádné jednorázové nákupy.</p>
      </v-layout>
      <div v-else class="basket-item client-shopItem" v-for="n in jednorazove_nakupy">
        <div class="basket-item__div">
          <div>
            <img src="@/assets/images/basket-item.png" alt="">
          </div>
          <div class="flex-column">
            <div class="flex">
              <p class="item-title">Obj. č. {{n.variabilni_symbol}}</p>
              <p class="item-title text-gray ml-3"> {{n.datum | formatSimpleDate}}</p>
            </div>
            <div class="flex flex-33">
              <p class="item-title text-gray">Stav: {{n.stav_objednavky.nazev}}</p>
              <p class="item-title text-gray ml-40">Cílová částka: {{n.castka_celkem | formatMoney}} {{n.mena.zkratka}}</p>
              <p class="item-title text-gray ml-40" v-if="n.castka_celkem_fixace > 0">Částka fixace: {{n.castka_celkem_fixace | formatMoney}} {{n.mena.zkratka}}</p>
            </div>
          </div>
        </div>
        <div class="basket-item__div basket-item__delete">
          <v-btn color="orange" class="bold" dark depressed @click="openDetailJN(n)"><v-icon class="detail-icon">remove_red_eyes</v-icon>Detail</v-btn>
          <!-- <v-btn color="grey" dark depressed flat @click="upravitJN(n)" v-if="n.stav_objednavky.stav=='nova'"><v-icon class="mr-2">edit</v-icon> Upravit</v-btn> -->
        </div>
      </div>
    </div>
  </v-container>
</template>
<script>
  import Base from '../../Base'
  import SporiciProgramDialog from '@/components/SporiciProgramDialog'
  import VytvoritSporiciProgramDialog from '@/components/VytvoritSporiciProgramDialog'
  import JednorazovyNakupDialog from '@/components/JednorazovyNakupDialog'
  import VytvoritJednorazovyNakupDialog from '@/components/VytvoritJednorazovyNakupDialog'
  export default {
    extends: Base,
    data () {
      return {
        loading: true,
        sporici_programy: [],
        jednorazove_nakupy: [],
        vytvoritSporiciProgram: false,
        sporici_program_id: null,
        jednorazovy_nakup_id: null,
        vytvoritJednorazovyNakup: false,
        vytvoritJednorazovyNakupEdit: false,
        vytvoritJednorazovyNakupID: ""
      }
    },
    props: {
      klient: String
    },
    mounted () {
      this.load();
    },
    methods: {
      load (f) {
        window.API.get("klient/nakupy/"+this.$props.klient).then(function(body) {
          this.sporici_programy = body.sporici_programy;
          this.jednorazove_nakupy = body.jednorazove_nakupy;
          this.loading = false;
        }.bind(this)).catch(function(err) {
          console.log(err);
        }.bind(this));
      },
      createClick () {
        this.vytvoritSporiciProgram = true;
      },
      createJNClick () {
        this.vytvoritJednorazovyNakupID = null;
        this.vytvoritJednorazovyNakupEdit = false;
        this.vytvoritJednorazovyNakup = true;
      },
      createdSporiciProgram () {
        this.vytvoritSporiciProgram = false;
        this.load();
      },
      createdJednorazovyNakup () {
        this.vytvoritJednorazovyNakup = false;
        this.vytvoritJednorazovyNakupEdit = false;
        this.vytvoritJednorazovyNakupID = null;
        this.load();
      },
      openDetail (n) {
        this.sporici_program_id = n.id;
      },
      openDetailJN (n) {
        this.jednorazovy_nakup_id = n.id;
      },
      upravitJN (n) {
        this.vytvoritJednorazovyNakup = true;
        this.vytvoritJednorazovyNakupEdit = true;
        this.vytvoritJednorazovyNakupID = n.id.toString();
      },
      // upravit (n) {
      //   this.vytvoritSporiciProgram = true;
      //   this.vytvoritSporiciProgramEdit = true;
      //   this.vytvoritSporiciProgramID = n.id.toString();
      // }
    },
    components: {
      SporiciProgramDialog, JednorazovyNakupDialog, VytvoritSporiciProgramDialog, VytvoritJednorazovyNakupDialog
    }
  }
</script>
